import cx from 'classnames';

import { Heading } from 'components/Heading';

import { TPortfolioImage } from 'types/portfolio';

import s from './ImageWithText.module.css';
interface ImageWithTextProps {
  heading: string;
  content: string;
  image?: TPortfolioImage;
  reverseRow?: boolean;
  showPortfolio: boolean;
}

export const ImageWithText = ({
  reverseRow = false,
  heading,
  content,
  image,
  showPortfolio,
}: ImageWithTextProps) => {
  return (
    <div
      className={cx(s.container, {
        [s.reverseRow]: reverseRow,
        [s.noImage]: !image || !image.image || !showPortfolio, // Assuming image.image is your validity check
      })}
    >
      <Heading className={s.heading} as="h3" variant="large">
        {heading}
      </Heading>
      <p className={s.content}>{content}</p>
      {image && image.image && showPortfolio && (
        <figure
          className={s.figure}
          style={{
            backgroundImage: `url(${image.image.original})`,
          }}
        />
      )}
    </div>
  );
};
